import fp from 'lodash/fp';
import { createSelector } from 'reselect';
import { getAvailability as stateContext } from './availability';

export const getPagination = createSelector(
  stateContext,
  fp.get('byUniqPagination')
);

export const getPaginationPages = createSelector(
  getPagination,
  fp.get('pages')
);

export const getPaginationWithoutPages = createSelector(
  getPagination,
  fp.omit('pages')
);

export const getPaginationQueryOptions = createSelector(
  getPagination,
  ({ currentPage: page, limit }) => ({
    page,
    limit
  })
);

export const getPaginationLoadedPages = createSelector(
  getPaginationPages,
  fp.mapValues(() => true)
);

export const getCurrentPageItems = createSelector(stateContext, state => {
  const page = fp.getOr(1, 'byUniqPagination.currentPage', state);
  const pageItemIds = fp.get(`byUniqPagination.pages.${page}.ids`, state);
  const pageItemsByIds = fp.pick(pageItemIds, state.byUniqId);

  return fp.values(pageItemsByIds);
});
